import { Injectable } from '@angular/core'
import { CollectionRepository } from '@engineering11/web-api-firebase'
import { COLLECTIONS } from '../constants'
import { IEmployer } from '../model/employer.model'

@Injectable({ providedIn: 'root' })
export class EmployerRepository extends CollectionRepository<IEmployer> {
  protected COLLECTION = COLLECTIONS.EMPLOYER
}
